import { createAction, props } from '@ngrx/store';
import { DepartmentApiModel } from 'app/models/department-api.model';

export const loadDepartments = createAction('[Departments] Load');

export const loadDepartmentsSuccess = createAction(
  '[Departments] Load Successful',
  props<{ items: DepartmentApiModel[] }>()
);

export const loadDepartmentsFailed = createAction(
  '[Departments] Load Failed',
  props<{ error: any }>()
);

export const resetDepartments = createAction('[Departments] Reset');
